export default "__VITE_ASSET__CYCl$X5Q__"